import React from "react";
import colors from "theme/config/colors";
import Button, { Theme } from "theme/components/buttons/Button";

const RedSolidButton = (props: any) => {
    const theme: Theme = {
        color: colors.white,
        backgroundColor: colors.red,
        hover: {
            color: colors.red,
            backgroundColor: "transparent",
            borderColor: colors.red,
        },
        disabled: {
            opacity: "50%",
        },
    };

    return <Button {...props} theme={theme} />;
};

export default RedSolidButton;
